import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { mustMatchValidator } from 'src/app/modules/shared/helpers/helper';
import { AuthService } from 'src/app/services/auth.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-confirm-password',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.css'],
})
export class ConfirmPasswordComponent {


  resetPasswordForm: FormGroup;
  isPasswordVisible = false;
  isConfirmPasswordVisible = false;
  isLoading: boolean = false
  constructor(private fb: FormBuilder,private toasterService: ToastrService,private authService: AuthService,private localStorageService: LocalStorageService,private router: Router) {
    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      cpassword: ['', [Validators.required, Validators.minLength(8)]]
    },
    { validators: mustMatchValidator('password', 'cpassword') });
  }

  /**
   * Submits the confirm password form to the server
   * This function first checks if the form is valid.
   * If it is, it calls the AuthService's resetNewPassword method with the form values and the email and otp stored in local storage.
   * If the response is successful, it shows a successful toast, removes the email and otp from local storage, resets the form, and navigates to the login page.
   * If the response is an error, it shows an error toast with the error message.
   */
  onSubmit(): void {
    this.isLoading = true
    if (this.resetPasswordForm.valid) {
      // Handle the form submission
      this.authService.resetNewPassword(this.resetPasswordForm.value.password,this.localStorageService.get('email')??'',Number(this.localStorageService.get('otp'))).subscribe({
        next: (res: any) => {
          this.isLoading = false;
          this.toasterService.success(res.message);
          this.localStorageService.remove('email');
          this.localStorageService.remove('otp');
          this.resetPasswordForm.reset();
          this.resetPasswordForm.markAsUntouched();
          this.router.navigate(['/auth/login']);
        },
        error: (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.toasterService.error(err.error.message);
        }
      })

    }
  }



/**
 * Toggles the visibility of the password field.
 * Switches the `isPasswordVisible` flag between true and false.
 */

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  /**
   * Toggles the visibility of the confirm password field.
   * Switches the `isConfirmPasswordVisible` flag between true and false.
   */
  toggleConfirmPasswordVisibility() {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  }
}
